export type TagRequestBody = {
  text: string;
};
